export const UPDATE_SPARKED_COCO_MARKER_DATA = 'UPDATE_SPARKED_COCO_MARKER_DATA'

export function sparkedCocoMarkersDataReducer (state = [], action) {
    switch (action.type){
        case UPDATE_SPARKED_COCO_MARKER_DATA:
            let combineArray = [...state, ...action.payload]
            return combineArray
        default: return state
    }
}